"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the result of multiplying the given double-double by 2.
 * @param q low order double
 * @param Q hight order double
 */
function qMultBy2([q, Q]) {
    return [2 * q, 2 * Q];
}
exports.qMultBy2 = qMultBy2;
//# sourceMappingURL=q-mult-by-2.js.map